import type { Feature, GeoJsonProperties } from 'geojson';

export const MAP_POINT_AREA_HA = 3.99;
export const MAP_POINT_MAX_AREA_HA = 4;
export interface MapPointDraft {
  id?: string;
  name: string;
  lat: number | null;
  lng: number | null;
  areaHa: number | null;
}
export interface MapPointEditorResult extends MapPointDraft {
  action: 'save' | 'pick';
}

export function pointAreaHa(properties: GeoJsonProperties | undefined): number {
  const area = properties?.['Area'] ?? properties?.['areaHa'];
  return typeof area === 'number' && Number.isFinite(area) ? area : MAP_POINT_AREA_HA;
}

export function pointAreaLabel(properties: GeoJsonProperties | undefined): string {
  return `${pointAreaHa(properties).toFixed(2)} ha`;
}

export function withPointArea(properties: GeoJsonProperties | undefined, areaHa: number): GeoJsonProperties {
  const { areaHa: _legacy, ...rest } = properties ?? {};
  return { ...rest, shape: 'point', Area: areaHa };
}

export function isValidPointArea(area: unknown): area is number {
  return typeof area === 'number' && Number.isFinite(area) && area > 0 && area <= MAP_POINT_MAX_AREA_HA;
}

export function pointsWithInvalidArea(features: Feature[]): string[] {
  return features
    .filter((feature) => feature.geometry?.type === 'Point')
    .flatMap((feature, index) =>
      isValidPointArea(feature.properties?.['Area']) ? [] : [feature.properties?.['name'] || `Point ${index + 1}`]
    );
}
